import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2
} from '@angular/core'

export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right'

@Directive({
  selector: '[appHtmlTooltip]',
  standalone: true
})
export class HtmlTooltipDirective {
  @Input('appHtmlTooltip') tooltipContent!: string
  @Input() appHtmlTooltipPosition: TooltipPosition = 'bottom'

  private tooltipElement!: HTMLElement

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    this.showTooltip()
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.hideTooltip()
  }

  private showTooltip() {
    if (!this.tooltipContent) return

    // Create tooltip element
    this.tooltipElement = this.renderer.createElement('div')
    this.tooltipElement.innerHTML = this.tooltipContent // Support HTML content
    this.renderer.appendChild(document.body, this.tooltipElement)

    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute')
    this.renderer.setStyle(this.tooltipElement, 'background', '#142f4e')
    this.renderer.setStyle(this.tooltipElement, 'color', '#fff')
    this.renderer.setStyle(this.tooltipElement, 'padding', '5px 10px')
    this.renderer.setStyle(this.tooltipElement, 'border-radius', '4px')
    this.renderer.setStyle(this.tooltipElement, 'z-index', '1000')
    this.renderer.setStyle(this.tooltipElement, 'pointer-events', 'none')
    this.renderer.setStyle(this.tooltipElement, 'max-width', '320px')
    this.renderer.setStyle(this.tooltipElement, 'font-size', '1.5rem')

    const hostPos = this.el.nativeElement.getBoundingClientRect()
    const gap = 8
    const hostCenterX = hostPos.left + window.scrollX + hostPos.width / 2
    const hostCenterY = hostPos.top + window.scrollY + hostPos.height / 2

    switch (this.appHtmlTooltipPosition) {
      case 'top':
        this.renderer.setStyle(
          this.tooltipElement,
          'top',
          `${hostPos.top + window.scrollY - gap}px`
        )
        this.renderer.setStyle(
          this.tooltipElement,
          'left',
          `${hostCenterX}px`
        )
        this.renderer.setStyle(
          this.tooltipElement,
          'transform',
          'translate(-50%, -100%)'
        )
        break
      case 'left':
        this.renderer.setStyle(
          this.tooltipElement,
          'top',
          `${hostCenterY}px`
        )
        this.renderer.setStyle(
          this.tooltipElement,
          'left',
          `${hostPos.left + window.scrollX - gap}px`
        )
        this.renderer.setStyle(
          this.tooltipElement,
          'transform',
          'translate(-100%, -50%)'
        )
        break
      case 'right':
        this.renderer.setStyle(
          this.tooltipElement,
          'top',
          `${hostCenterY}px`
        )
        this.renderer.setStyle(
          this.tooltipElement,
          'left',
          `${hostPos.right + window.scrollX + gap}px`
        )
        this.renderer.setStyle(
          this.tooltipElement,
          'transform',
          'translateY(-50%)'
        )
        break
      case 'bottom':
      default:
        this.renderer.setStyle(
          this.tooltipElement,
          'top',
          `${hostPos.bottom + window.scrollY + gap}px`
        )
        this.renderer.setStyle(
          this.tooltipElement,
          'left',
          `${hostCenterX}px`
        )
        this.renderer.setStyle(
          this.tooltipElement,
          'transform',
          'translateX(-50%)'
        )
        break
    }
  }

  private hideTooltip() {
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement)
      this.tooltipElement = null!
    }
  }
}
